'use strict';

var n = require('react');
var s = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var n__default = /*#__PURE__*/_interopDefault(n);
var s__default = /*#__PURE__*/_interopDefault(s);

var p=s__default.default.svg`
  height: ${({$size:t})=>t};
  width: ${({$size:t})=>t};
  fill: ${({$fill:t})=>t};
`;function g({size:t="16px",onClick:o,children:r,fill:i="",viewBox:e="0 0 16 16",style:l={}}){return n__default.default.createElement(p,{xmlns:"http://www.w3.org/2000/svg",onClick:o,$fill:i||"none",$size:t,viewBox:e,style:l},r)}var $=g;

exports.a = $;
